// RoleRoute.jsx
import { Navigate } from "react-router-dom";
import { getAuthUser, isLoggedIn } from "./authHelper";

/* ===================== PATRON ===================== */
export const PatronRoute = ({ children }) => {
  if (!isLoggedIn()) {
    return <Navigate to="/user-login" replace />;
  }

  const user = getAuthUser();
  if (user?.role !== "Patron") {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

/* ===================== MEALHOST ===================== */
export const MealHostRoute = ({ children }) => {
  if (!isLoggedIn()) {
    return <Navigate to="/user-login" replace />;
  }

  const user = getAuthUser();
  if (user?.role !== "MealHost") {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

/* ===================== ADMIN ===================== */
export const AdminRoleRoute = ({ children }) => {
  if (!isLoggedIn()) {
    return <Navigate to="/admin/dashboard/login" replace />;
  }

  const user = getAuthUser();
  if (user?.role !== "Admin") {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};
